function hasActiveStandardsFilter(filters = {}) {
  return ['indicators', 'expectations', 'standards'].some(key => Array.isArray(filters[key]) && filters[key].length > 0)
}
module.exports = {hasActiveStandardsFilter}
